<template>
    <div class="searcher-wrapper">
        <div class="search-description-wrapper">
            <!-- {{ $trans('web_search.enter_search_term_and_select_matching_candidates') }} -->
        </div>
        <div class="search-bar-wrapper">
            <div class="search-bar-wrapper-inner">
                <el-select-v2 v-model="value" class="search-select" :options="SearchOptionsStore.getOptions()" :placeholder="$trans('web_search.enter_search_term_or_choose_from_preselection')" filterable multiple :multiple-limit="3" :reserve-keyword="false" autocomplete="off" scrollbar-always-on />
                <el-switch
                    v-model="modifier"
                    inline-prompt
                    :active-text="$trans('web_search.filters.and')"
                    :inactive-text="$trans('web_search.filters.or')"
                    active-value="AND"
                    inactive-value="OR"
                />
            </div>
            <el-button class="search-btn" :type="type" :disabled="disabled" @click="submit">
                {{ $trans('web_search.start_search') }}
            </el-button>
            <el-link class="el-button search-with-ai-button" :underline="false" href="https://matchmaker.de">
                {{ $trans('web_search.ai_search') }}
                <img src="/media/images/ai_icon_white.svg" class="ai-icon">
            </el-link>
        </div>
    </div>
</template>

<script>
import { mapStores } from 'pinia'
import { useSearchOptionsStore } from '@/stores/SearchOptionsStore'

export default {
    props: {
        mainFilters: {
            type: Array,
            required: true,
        },
    },
	data() {
		return {
			type: 'info',
			disabled: true,
			value: [],
            options: [],
            modifier: 'AND',
		}
	},
    mounted() {
        this.loadOptions();
    },
	computed: {
        ...mapStores(useSearchOptionsStore), // useSearchOptionsStore => this.SearchOptionsStore
		selectedCompetencesIds() {
			return this.value.map((item) => item.split('_')).filter(item => (item[0] == 'competence')).map(item => item[1]);
		},
		selectedJobTagsIds() {
			return this.value.map((item) => item.split('_')).filter(item => (item[0] == 'jobtag')).map(item => item[1]);
		},
	},
	watch: {
		value() {
			this.type = this.value.length ? 'primary' : 'info';
			this.disabled = !this.value.length;
		},
        mainFilters() {
            this.SearchOptionsStore.setActiveFilters(this.mainFilters);

            if (this.SearchOptionsStore.getOptions().length) {
                let self = this;
                setTimeout(function () {
                    self.setOptions();
                }, 2500);
            }
        },
	},
	methods: {
		submit() {
            if (this.selectedCompetencesIds.length || this.selectedJobTagsIds.length) {
                this.$emit('newSearch', {
                    competence: this.selectedCompetencesIds.join('-'),
                    job_tag: this.selectedJobTagsIds.join('-'),
                    modifier: this.modifier,
                });
            }
		},
        async loadOptions() {
            const options = this.fetchOptions();

            options.then((response) => {
                let optionsData = Object.entries(response.results).map(([idx, option]) => ({
                    value: option.id,
                    label: option.text,
                })).filter((option) => option.label);

                optionsData = optionsData.sort((a, b) => {
                    let index = 'label';
                    if (a[index] < b[index])
                        return -1;
                    if (a[index] > b[index])
                        return 1;
                    return 0;
                });
                this.SearchOptionsStore.setOptions(optionsData);

                let self = this;
                setTimeout(function () {
                    self.setOptions();
                }, 2500);
            });
        },
        async fetchOptions() {
            let pathname = window.location.pathname;
            if (pathname.startsWith('/')) {
                pathname = pathname.substring(1);
            }
            pathname = pathname.split('/');

            let poolLang = (pathname.length > 2) ? pathname[2] : 'de';

            const response = await fetch('/web-search/options/' + poolLang + '/?format=json');

            return await response.json();
        },
        setOptions() {
            this.value = this.mainFilters.map((option) => option.type + '_' + option.id);
        },
	}
}
</script>

<style scoped>
.searcher-wrapper {
    display: grid;
    justify-content: center;
}

.search-description-wrapper {
    padding-top: 25px;
}

.search-bar-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    padding-top: 25px;
}

.search-btn {
    margin-left: 15px;
    border-radius: 24px;
    padding-left: 30px;
    padding-right: 30px;
    background-color: #41ABC4;
    color: #fff;
}

.search-with-ai-button {
    margin-left: 15px;
    border-radius: 24px;
    padding-left: 30px;
    padding-right: 30px;
    color: #fff;
    border: none;
    cursor: pointer;
    font-size: 16px;
    background: linear-gradient(90deg,
        #a06dd6,
        #9e6ed6,
        #8f7ad1,
        #8682cf,
        #8385ce,
        #7e89cd,
        #7a8dcc,
        #7690ca,
        #7294c9,
        #6d9ac7,
        #6d9ac7,
        #699fc6,
        #68a0c6,
        #67a2c5
    );
    background-size: 200%;
    background-position: 0%;
    transition: background-position 0.3s ease-in-out;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    padding: 10px 20px;
    font-size: 16px;
}

.search-with-ai-button:hover {
    background: #B465D8 !important;
    text-decoration: none;
}

.ai-icon {
    width: 20px;
    height: 20px;
    margin-left: 10px;
}


.el-button--primary {
	--el-button-text-color: var(--el-color-white);
	--el-button-bg-color: #41ABC4;
	--el-button-border-color: #41ABC4;
	--el-button-outline-color: var(--el-color-primary-light-5);
	--el-button-active-color: var(--el-color-primary-dark-2);
	--el-button-hover-text-color: var(--el-color-white);
	--el-button-hover-link-text-color: var(--el-color-primary-light-5);
	--el-button-hover-bg-color: #2699b2;
	--el-button-hover-border-color: #2699b2;
	--el-button-active-bg-color: var(--el-color-primary-dark-2);
	--el-button-active-border-color: var(--el-color-primary-dark-2);
	--el-button-disabled-text-color: var(--el-color-white);
	--el-button-disabled-bg-color: var(--el-color-primary-light-5);
	--el-button-disabled-border-color: var(--el-color-primary-light-5);
}

.el-select.search-select {
    width: 500px;
}

.el-select:deep(.el-select__wrapper) {
    border: 1px solid #9C979A;
}

.el-select:deep(.el-select__caret) {
    color: #41abc4;
}

.el-select:deep(.el-icon.el-select__caret) {
    height: 2em;
    width: 2em;
}

.el-select:deep(.el-icon.el-select__caret svg) {
    height: 2em;
    width: 2em;
}

.el-switch,
.el-switch :deep(.el-switch__core) {
    height: 25px;
    border-radius: 20px;
}

.el-switch {
    --el-switch-on-color: #41ABC4;
    --el-switch-off-color: #707070;
    margin-right: 20px;
    margin-left: 20px;
}

.el-switch :deep(.el-switch__core .el-switch__inner .is-text) {
    padding: 0 4px;
}
@media only screen and (max-width: 790px) {
    .searcher-wrapper {
        min-height: calc(100vh - 150px);
        display: flex;
        justify-content: center;
        flex-direction: column;
        align-items: center;
        width: calc(100% - 50px);
        margin: 0 25px;
    }
    .search-bar-wrapper {
        flex-direction: column;
        width: 100%;
    }
    .search-bar-wrapper .search-bar-wrapper-inner {
        flex-grow: 1;
        display: flex;
        align-items: center;
        width: 100%;
    }
    .search-bar-wrapper .el-button {
        margin: 100px 0;
    }
    .search-bar-wrapper .el-switch {
        margin-right: 0;
    }
}
</style>
